"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityUpdateMutationFieldName = void 0;
var entityUpdateMutationFieldName = function (definition) {
  return "update".concat(definition.typeName);
};
exports.entityUpdateMutationFieldName = entityUpdateMutationFieldName;